function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M59.98,38.54c-.07-1.5-.41-2.96-1.11-4.25-1.18-2.19-3.32-3.75-5.71-4.37-3.58-.93-6.32.89-7.72,1.12-.04-8.82,2.74-17.46,7.95-24.62.36-.49.39-1.14.09-1.66-.3-.52-.88-.82-1.48-.77-18.23,1.83-31.54,13.98-34.14,30.38-.51-.14-.99-.33-1.45-.57-1.06-.45-2.22-.69-3.44-.69-2.66,0-5.22,1.22-6.9,3.29-4.38,5.4-1.21,14.15,3.01,18.64,2.78,2.95,6.6,4.93,10.7,4.93,6.56,0,12.1-4.94,14.44-10.84,1.35-3.39,2.01-7.83.27-11.2-1.46-2.84-4.41-4.72-7.6-4.82-.1,0-.2,0-.3,0-1.22,0-2.38.24-3.44.69-.68.36-1.44.61-2.24.74,2.35-13.84,13.1-24.33,28.04-27.04-4.32,7.02-6.61,15.13-6.6,23.39-.54-.14-1.06-.34-1.53-.59-1.06-.45-2.22-.69-3.44-.69-2.34,0-4.46.91-6.05,2.39.31-.29,3.79,2.13,5.24,5.24,1,2.16,1.24,5.27.92,7.94-.52,4.33-2.63,7.68-2.66,7.65,2.61,2.25,5.85,3.66,9.37,3.66,6.66,0,12.26-5.08,14.54-11.09.78-2.06,1.31-4.51,1.2-6.86ZM11.53,44.25c-1.69,0-3.05-1.37-3.05-3.06s1.37-3.06,3.05-3.06,3.05,1.37,3.05,3.06-1.37,3.06-3.05,3.06Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 64 64"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/lobby2.95acabb4.svg";
export { SvgComponent as ReactComponent };